module.exports = __webpack_public_path__ + "assets/7cb7506bc5f4c7d6b2cc8f3238c61182.mp3";